<div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
  <div class="bg-overlay"></div>
  <div class="auth-page-content overflow-hidden pt-lg-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card overflow-hidden">
            <div class="row g-0">
              <div class="col-lg-6">
                <div class="p-lg-5 p-4 auth-one-bg h-100">
                  <div class="bg-overlay"></div>
                  <div class="position-relative h-100 d-flex flex-column">
                    <div class="mb-4">
                      <a routerLink="/" class="d-block">
                        <img src="assets/images/logo.png" alt="" height="60">
                      </a>
                    </div>
                    <div class="mt-auto">
                      <div class="mb-3">
                        <i class="ri-double-quotes-l display-4 text-light"></i>
                      </div>

                      <div id="quotescarouselIndicators" class="carousel slide" data-bs-ride="carousel">
                        <div class="carousel-indicators">
                          <button type="button" data-bs-target="#quotescarouselIndicators" data-bs-slide-to="0"
                            class="active" aria-current="true" aria-label="Slide 1"></button>
                          <button type="button" data-bs-target="#quotescarouselIndicators" data-bs-slide-to="1"
                            aria-label="Slide 2"></button>
                          <button type="button" data-bs-target="#quotescarouselIndicators" data-bs-slide-to="2"
                            aria-label="Slide 3"></button>
                        </div>

                        <div class="carousel-inner text-center text-white pb-5">
                          <div class="carousel-item active">
                            <p class="fs-15 fst-italic">
                              " Gérez vos apprenants, leurs accès aux formations et leurs progrès en toute simplicité. "
                            </p>
                          </div>

                          <div class="carousel-item">
                            <p class="fs-15 fst-italic">
                              " Suivez en temps réel les achats de formations crypto et options binaires depuis votre
                              tableau de bord. "
                            </p>
                          </div>

                          <div class="carousel-item">
                            <p class="fs-15 fst-italic">
                              " Une plateforme d’administration qui vous permet d’optimiser la gestion de vos contenus,
                              ventes et utilisateurs. "
                            </p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="p-lg-5 p-4">
                  <h5 class="text-primary">Mot de passe oublié?</h5>
                  <p class="text-muted">Réinitialiser le mot de passe de votre compte.</p>
                  <div class="my-4 text-center">
                    <i class="ri-mail-send-line display-4 text-primary"></i>
                  </div>
                  <div class="alert border-0 alert-primary text-center mb-2 mx-2" role="alert">
                    Entrez votre email et des instructions vous seront envoyées !
                  </div>

                  <div class="mt-4">
                    <form novalidate [formGroup]="requestForm" (ngSubmit)="emailSignIn()">

                      <div class="mb-3">
                        <label class="form-label" for="email">Email</label>
                        <input type="email" class="form-control" placeholder="exemple@email.com" id="email"
                          formControlName="email" [ngClass]="{ 'is-invalid': submitted && form['email'].errors }">
                        <div *ngIf="submitted && form['email'].errors" class="invalid-feedback">
                          <div *ngIf="form['email'].errors['required']"> L'adresse e-mail est obligatoire </div>
                          <div *ngIf="form['email'].errors['email']"> Veuillez entrer une adresse e-mail valide </div>
                        </div>
                      </div>

                      <div class="mt-4">
                        <button class="btn btn-primary w-100 " type="submit">
                          {{loading? 'Veuillez patienter ' : 'Envoyer' }}
                          <span class="{{ loading? 'spinner-border spinner-border-sm ms-2' : '' }}" role="status">
                          </span>
                        </button>
                      </div>

                      <div class="mt-5 text-center">
                        <p class="mb-0">
                          Attendez, je me souviens de mon mot de
                          passe...
                          <a href="javascript:void(0)" (click)="onLogin()"
                            class="fw-semibold text-primary text-decoration-underline">
                            Cliquez ici
                          </a>
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center">
            <p class="mb-0">&copy;
              <script>document.write(new Date().getFullYear())</script> SappTradingPro. Crafted with <i
                class="mdi mdi-heart text-danger"></i> by <a href="#" target="_blank"
                class="text-reset">SA</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
